import React, { useState } from 'react';
import { Col, Divider, Row } from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import AuthorizedPersonDrawerForm from '../AuthorizedPersonDrawerForm';

const AuthorizedPersonContent = ({
  text,
  title,
  field,
  onRemove,
  index,
  forceRender,
  setForceRender,
}) => {
  const [visible, setVisible] = useState(false);

  const openDrawer = () => {
    setVisible(true);
    setForceRender(false);
  };

  const closeDrawer = () => {
    setVisible(false);
    setForceRender(true);
  };

  return (
    <Row justify="space-between">
      <AuthorizedPersonDrawerForm
        closeDrawer={closeDrawer}
        visible={visible}
        title={title}
        field={field}
        onRemove={onRemove}
        index={index}
        forceRender={forceRender}
      />
      <Col lg={12} xs={24}>
        <span>{text}</span>
      </Col>
      <Col lg={12} xs={24}>
        <div className="personalDocumentsForm__button">
          <div className="personalDocumentsForm__icon">
            <EditOutlined onClick={openDrawer} style={{ marginRight: '0.5rem' }} />
            <DeleteOutlined onClick={() => onRemove(field.name)} />
          </div>
        </div>
      </Col>
      <Divider style={{ marginTop: 10, marginBottom: 0, marginLeft: '-4%' }} />
    </Row>
  );
};

AuthorizedPersonContent.propTypes = {
  text: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  field: PropTypes.shape().isRequired,
  onRemove: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  forceRender: PropTypes.bool,
  setForceRender: PropTypes.func.isRequired,
};

AuthorizedPersonContent.defaultProps = {
  forceRender: false,
};

export default AuthorizedPersonContent;
